import type { DashboardNotificationEntityTypeDto } from "@/api/types";
import { BarChart10Icon } from "@/components/Icons/BarChart10Icon";
import { Bell01Icon } from "@/components/Icons/Bell01Icon";
import { CalendarIcon } from "@/components/Icons/CalendarIcon";
import { ClipboardCheckIcon } from "@/components/Icons/ClipboardCheckIcon";
import { Mail01Icon } from "@/components/Icons/Mail01Icon";
import { Tool02Icon } from "@/components/Icons/Tool02Icon";

/** Maps notification types to their icon and falls back to the generic notification bell. */
export function ResidentNotificationIcon({ type }: { type: DashboardNotificationEntityTypeDto }): React.ReactNode {
  switch (type) {
    case "event":
      return <CalendarIcon size={16} />;
    case "repairRequest":
    case "repairReaction":
    case "repairStatusChange":
    case "adminTicket":
      return <Tool02Icon size={16} />;
    case "message":
    case "messageCloseReminder":
      return <Mail01Icon size={16} />;
    case "survey":
      return <ClipboardCheckIcon size={16} />;
    case "poll":
    case "pollV2":
      return <BarChart10Icon size={16} />;
    default:
      return <Bell01Icon size={16} />;
  }
}
